export default "__VITE_ASSET__CXol2Q1I__"